
/**
 * Подключаем скрипты движка
 */
require('./cabinet');
require('./transfer');
require('./user');
require('./feedback');
require('./poems');
// require('./guestbook');
require('./noty');
// require('./ramkaSimple');
